<script lang="ts">
  import { css } from '@agapi/ui/panda/css';
  import { storyblokEditable } from '@storyblok/svelte';
  import type { HeadingStoryblokProps } from './heading.types';

  const { blok }: HeadingStoryblokProps = $props();

  const element = blok.element || blok.headingLevel;
  const styles = {
    textStyle: blok.headingLevel
  };
</script>

{#if element === 'h1'}
  <h1 use:storyblokEditable={blok} class={css(styles)}>{blok.text}</h1>
{:else if element === 'h2'}
  <h2 use:storyblokEditable={blok} class={css(styles)}>{blok.text}</h2>
{:else if element === 'h3'}
  <h3 use:storyblokEditable={blok} class={css(styles)}>{blok.text}</h3>
{:else if element === 'h4'}
  <h4 use:storyblokEditable={blok} class={css(styles)}>{blok.text}</h4>
{/if}